import React, { useEffect, useState } from "react";
import { Star } from "@phosphor-icons/react";
import { TESTIMONIALS } from "../data/testimonials";

export const TestimonialStrip = ({ items = TESTIMONIALS, interval = 6000 }) => {
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused || items.length < 2) return undefined;
    const t = setInterval(() => setI((x) => (x + 1) % items.length), interval);
    return () => clearInterval(t);
  }, [paused, items.length, interval]);

  if (!items.length) return null;
  const q = items[i % items.length];

  return (
    <div data-testid="testimonial-strip" className="mt-8 border-l-2 border-exodus-gold/60 pl-5"
      onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
      <div key={i} className="transition-opacity duration-500 animate-in fade-in">
        <div className="flex gap-1 text-exodus-gold" aria-label={`${q.rating || 5} out of 5 stars`}>
          {Array.from({ length: q.rating || 5 }).map((_, n) => <Star key={n} size={12} weight="fill" />)}
        </div>
        <p data-testid="testimonial-quote" className="text-sm text-exodus-text/85 mt-2 leading-relaxed">"{q.quote}"</p>
        <p data-testid="testimonial-name" className="text-xs text-exodus-muted mt-2">{q.name} · {q.location}</p>
      </div>
      {items.length > 1 && (
        <div className="flex gap-2 mt-4">
          {items.map((_, n) => (
            <button key={n} type="button" data-testid={`testimonial-dot-${n}`} aria-label={`Show quote ${n + 1}`} onClick={() => setI(n)}
              className={`h-1 transition-[width,background-color] duration-300 ${n === i % items.length ? "w-6 bg-exodus-gold" : "w-3 bg-exodus-border hover:bg-exodus-gold/50"}`} />
          ))}
        </div>
      )}
    </div>
  );
};
